import { AspectRatio } from '@material-ui/icons'
import { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setContainDisplay } from 'redux/actions/displayActions'
import { playerStyles } from './SwipeCard'

const AspectRatioControl = () => {
    const { containDisplay } = useSelector(state => state.display)
    const dispatch = useDispatch()
    return (
        <AspectRatio style={{ ...playerStyles.controlIcon, ...containDisplay ? { color: 'gray' } : {} }}
            onClick={(evt) => {
                evt.stopPropagation()
                dispatch(setContainDisplay(!containDisplay))
            }} />
    )
}
export default memo(AspectRatioControl)